import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {WorkoutSetId} from '../../domain/workout-set-id.value-object';

export class WorkoutSetIdValidator implements Validator<WorkoutSetId> {
  readonly standardSchema = z.templateLiteral(['wks', '_', z.string().min(1)]);

  validate(value: unknown): Result<WorkoutSetId, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid workout set id.'),
      );
    }
    return ok(parsed.data);
  }
}
